<template>
  <utd-toast ref="toastRef"
             class="persistent-login-toast"
             position="top-right"
             has-variable-text="true"
             :message="`You are signed in as ${firstName} ${lastName}`" />
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import UtdToast from '_acaSrc/components/shared/stdlib/UtdToast.vue';
import { SET_IS_NEW_BROWSER_SESSION } from '_acaSrc/store/auth.store';

const store = useStore();
const toastRef = ref(null);

const firstName = computed(() => store.getters['user/userFirstName'] || '');
const lastName = computed(() => store.getters['user/userLastName'] || '');

const shouldShowToast = computed(() =>
    store.getters['app/isAppDataLoaded']
        && store.getters['user/userLoggedIn']
        && store.getters['feature/isPersistentLoginEnabled']
        && store.getters['auth/isNewBrowserSession']
);

watch(shouldShowToast, show => {
    if (show) {
        toastRef.value?.show();
        store.commit(`auth/${SET_IS_NEW_BROWSER_SESSION}`, false);
    }
}, { immediate: true });
</script>

<style lang="less" scoped>
.persistent-login-toast :deep(.utd-notification .utd-notification-content) {
  padding-right: 30px;

  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
  }
}
</style>
